export enum ECabinType {
    FirstClass = "FIRST CLASS",
    BusinessClass = "BUSINESS CLASS",
    EconomyClass = "ECONOMY CLASS",
}
